/*
    Fichier pour la page d'accueil
 */

$(function() {
    /*
      Carousel de titre sur la home
     */
    var homeSettings = {
        arrows: false,
        autoplay: true, // joue automatiquement
        autoplaySpeed: 5000,
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        swipe: true
    };
    if ($('.scroll-down').length){
        $('.scroll-down').off('click').on('click', function () {
            const next = $('.link-anchor').offset().top
            $(document).scrollTo(next, 400)

        })
    }
    /**
     * CHUV18MA-374 - SVG fix
     */
    $('#heroCarousel').on('init', function(event, slick) {
      if(navigator.userAgent.indexOf('MSIE')!==-1
        || navigator.appVersion.indexOf('Trident/') > -1){
        var images = $("#heroCarousel .slide-img img")
        for (var i = 0; i < images.length; i++) {
          images[i].src = images[i].src+"?time=" + new Date();
        }
      }
    });

    $('#heroCarousel').slick(homeSettings);

    // On réactive le carousel si la personne passe >= 768px
    $(window).on('resize', function() {
        if ($(window).width() > 767 && !$('#heroCarousel').hasClass('slick-initialized')) {
            return $('#heroCarousel').slick(homeSettings);
        }
    });

    $('.hero-slide').on('click', function() {
        if ($(window).width() < 992) {
            var $links = $(this).find('a');
            if ($links.length) {
                window.location.href = $links.first().attr('href');
            }
        }
    });

    /*
        Carousel de l'agenda
     */
    $('#agenda-carousel').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 4, // sera overridé par le responsive
        slidesToScroll: 1,
        appendArrows: '#agenda-carousel-container',
        prevArrow: '<div class="col-xs-1"><button type="button" title="Précédent" class="slick-prev"><i class="fa fa-chevron-circle-left" aria-hidden="true"></i></button></div>',
        nextArrow: '<div class="col-xs-1"><button type="button" title="Suivant" class="slick-next"><i class="fa fa-chevron-circle-right" aria-hidden="true"></i></button></div>',
        responsive: [
            {
                breakpoint: 1260,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 820,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 550,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    /*
        Carousel des actualités
     */
    $('#actualites-carousel').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3, // sera overridé par le responsive
        slidesToScroll: 1,
        appendArrows: '#actualites-carousel-container',
        prevArrow: '<div class="col-xs-1"><button type="button" title="Précédent" class="slick-prev"><i class="fa fa-chevron-circle-left" aria-hidden="true"></i></button></div>',
        nextArrow: '<div class="col-xs-1"><button type="button" title="Suivant" class="slick-next"><i class="fa fa-chevron-circle-right" aria-hidden="true"></i></button></div>',
        responsive: [
            {
                breakpoint: 1260,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 760,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });
});
